/**
 * ARTICLE_CONTENT
 */
$(document).ready(function () {
	$(document).on("click", ".article-text img", function (event) {
		BigPicture({
			el: event.target,
		});
	});

	$(document).on("click", "[data-this-url]", function (event) {
		var thisLink = $(this).attr("href");
		var thisLocale = thisLink == "?lang=en" ? "en" : "ru";
		localStorage.setItem("currentLocale", thisLocale);
	});
});

/**
 * CART
 */
/*
 $(document).ready(function() {
	var mainCart = new CartMan({
	  declination: ["товар", "товара", "товаров"],
	  hideCartItems: true, // Скрывать поля корзины при удалении? [data-item-id]
	  counterTemplate: "(%c%)", // regexp %c% (%c% - counter)
	  counterTemplateEmpty: null, // regexp %c% (Шаблон для пустой корзины)
	  positionsTemplate: "(%c%)", // regexp %c% (%c% - counter)
	  positionsTemplateEmpty: null, // regexp %c% (Шаблон для пустой корзины)
	  counterItemsText: "В вашей корзине %c%&nbsp;%w%", // regexp %c%,%w% (%c% - counter, %w% - word)
	  counterItemsTextEmpty: "В вашей корзине %c%&nbsp;%w%", // regexp %c%,%w% (%c% - counter, %w% - word)
	  counterPositionText: "В вашей корзине %c%&nbsp;%w%", // regexp %c%,%w% (%c% - counter, %w% - word)
	  counterPositionTextEmpty: "В вашей корзине %c%&nbsp;%w%", // regexp %c%,%w% (%c% - counter, %w% - word)
	  updateItems: function(cart) {
		 if (cart.order_lines.length == 0) {
			$("[data-cart-quick]").hide();
			$(".cart_sidebar").hide();
			$(".cart-item").hide();
			$(".cart-empty").removeClass("hide");
		 }
	  }
	});
 */

/**
 * CATEGORY
 */
$(document).ready(function () {
	$(".category_menu-item[data-tabs-container]").dataTabs({
		state: "accordion",
		useJqMethods: false,
	});
});

/**
 * COLLECTION_FILTERS
 */
$(document).ready(function () {
	initCollectionFilter();

	$(document).on("click", "[data-open-filter]", function (event) {
		event.preventDefault();
		alertify.panel({
			target: ".collection-filter",
			position: "left",
			onOpen: function () {
				initCollectionFilter();
				$("body").addClass("open-collection-filter");
			},
			onclose: function () {
				$("body").removeClass("open-collection-filter");
			},
		});
	});
});

function initCollectionFilter() {
	/*
	$(".js-filter-section").dataTabs({
	  state: "accordion",
	  useJqMethods: false
	});
	$(".js-filter-range-slider").rangeSlider({
	  force_edges: true
	});
	$(".js-filter-range-slider-price").rangeSlider({
	  force_edges: true
	});
	*/
}

/*
$(function () {
	$(".js-filter-trigger").on("change", function (event) {
		$(this).parents("form:first").submit();
	});
	$(document)
		.on("click", "label", function (event) {
			var $form = $(this).parents("form:first");
			var $filterItem = $(this).parents(".filter-item");
			var $checkbox = $filterItem.find(":checkbox");

			if ($form.hasClass("collection-filter")) {
				event.preventDefault();
				$checkbox.prop("checked", !$checkbox.prop("checked")).trigger("change");
			}
		})
		.on(
			"change",
			"input:not(.js-filter-range-placeholder), select",
			function (event) {
				var $form = $(this).parents("form:first");

				sendFilter($form, $(this));
			}
		)
		.on("click", '[type="submit"]', function (event) {
			var $form = $(this).parents("form:first");

			if ($form.hasClass("collection-filter")) {
				event.preventDefault();
				sendFilter($form, $(event.target));
			}
		})
		.on("check", ".collection-filter", function (event) {
			sendFilter($(this), $(this));
		});

	function sendFilter($form, $source) {
		if (!$form.hasClass("collection-filter")) {
			return false;
		}
		var isSubmitOnChange = $form.data("submit-onchange");
		var isButton = $source.is("button");

		if (isSubmitOnChange || isButton) {
			$form.submit();
		}
	}
});
*/
/**
 * COLLECTIONINFINITY
 */
/*
$(document).ready(function () {
 
	if ($("[data-collection-infinity]").length) {
		var html = document.documentElement;
		$(window).on("scroll", function (event) {
			var scrollTop = Math.max(
				window.pageYOffset,
				document.documentElement.scrollTop,
				document.body.scrollTop
			);
			scrollTop -= document.documentElement.clientTop;
			var part = 1.7; // на это число разделиться высота контейнера с товарами

			var collscroll =
				$("[data-collection-infinity]").get(0).offsetTop +
				$("[data-collection-infinity]").outerHeight() / part;

			if (scrollTop > collscroll) {
				collectionInfinity();
			}
		});
	}

	// массив tempPage хранит метки страниц которые уже загрузили
	var tempPage = [];
	function collectionInfinity() {
		var _nextPage = $("[data-collection-infinity]").data("collection-infinity");
		if (_nextPage && _nextPage != "") {
			if (tempPage.indexOf(_nextPage) > -1) {
				return;
			}
			tempPage.push(_nextPage);
			$("body").addClass("body--loading");

			// грузим контент
			$.ajax({
				url: _nextPage,
				dataType: "html",
			})
				.done(function (_dom) {
					var $dom = $(_dom);
					var $next = $dom.find("[data-collection-infinity]");
					var _next = $next.data("collection-infinity");
					$("[data-collection-infinity]").append($next.html());
					$("[data-collection-infinity]")
						.data("collection-infinity", _next)
						.attr("data-collection-infinity", _next);

					$("[data-product-id]").each(function (index, el) {
						Products.initInstance($(el));
					});
				})
				.always(function () {
					$("body").removeClass("body--loading");
				});
		}
	}
});
*/

/**
 * DECLINATION
 */
/**
 * Склонение слов
 * @param  {number} _day  число
 * @param  {array} titles массив слов
 * @return {string}       склонение
 *
 * declinationText(2, ['человек', 'человека', 'человек'])
 * => 'человека'
 */
var declinationText = function (_day, titles) {
	var day = Math.round(_day);
	var _titles = ["товар", "товара", "товаров"];
	if (titles) {
		_titles = titles;
	}
	var cases = [2, 0, 1, 1, 1, 2];
	return _titles[
		day % 100 > 4 && day % 100 < 20 ? 2 : cases[day % 10 < 5 ? day % 10 : 5]
	];
};

/**
 * DYNAMIC_BASKET
 */
/*
 $(document).ready(function() {
	EventBus.subscribe("update_items:insales:cart", function(cart) {
	  $(".js-dynamic_basket").html(templateLodashRender(cart, "dynamic_basket"));
	  // инициализация items
	  InSalesUI.initAjaxInstance($(".js-dynamic_basket"));
	});
 });
 */

/**
 * FIXED_HEADER
 */
$(document).ready(function () {
	var fixed_header = new DetectiveScroll({
		trigger: {
			el: $(".fixed_header"),
			scroll: $(".main-header").outerHeight(),
		},
	});
});

/**
 * HITS
 */
$(document).ready(function () {
	var hitsSlider = InitSwiper($(".js-hits .js-products-slider"), {
		autoLength: true,
		loop: false,
		minCartWidth: 270,
		spaceBetween: 30,
		autoResponsive: false,
	});

	$(".js-hits").dataTabs({
		onInit: function () {
			setTimeout(function () {
				$.each(hitsSlider, function (index, el) {
					el.update();
				});
			}, 100);
		},
		onTab: function () {
			$.each(hitsSlider, function (index, el) {
				el.update();
			});
		},
	});
});

/**
 * INSTAGRAM
 */
/*
$(document).ready(function () {
	if ($(".js-instagram").length) {
		// Получаем фотографии из API
		var myInstagram = new InstagramPhotos({
			user_id: 5720831737,
			access_token: "5720831737.1677ed0.75c5924295bb49eaa35c62372aabfd64",
			countPhoto: 20,
			// filterImages: function (image){
			//   return image.likes.count > 0
			// },
			done: function (photos) {
				console.log(photos);
				$(".js-instagram .swiper-container").html(
					templateLodashRender({ photos: photos }, "insta-footer")
				);

				setTimeout(function () {
					instaSlider();
				}, 100);
			},
			fail: function (error) {
				if (error.meta) {
					console.warn(error.meta.error_message);
				}
			},
		});
	}

	function instaSlider() {
		var instagramSlider = InitSwiper(".js-instagram", {
			autoLength: true,
			minCartWidth: 300,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			speed: 600,
			setWrapperSize: true,
			paginationClickable: true,
			loop: true,
			preventClicks: true,
			controlBy: "container",
			spaceBetween: 0,
		});
	}
});
*/
/**
 * MOBILE_MENU
 */
$(document).ready(function () {
	$(document).on("click", "[data-open-mobile]", function (event) {
		event.preventDefault();
		var target =
			'[data-target-mobile-menu="' + $(this).data("open-mobile") + '"]';
		alertify.panel({
			target: target,
			position: "left",
			onOpen: function () {
				$("body").addClass("open-collection-filter");
				$("body").addClass("open-mobile-menu");
				$(".mobile_menu-item[data-tabs-container]").dataTabs({
					state: "accordion",
					initOpenTab: false,
					onInit: function (ins) {
						ins.closeAllTabs();
					},
				});
			},
			onclose: function () {
				$("body").removeClass("open-collection-filter");
				$("body").removeClass("open-mobile-menu");
			},
		});
	});
});

/**
 * MODALS
 */

$(document).ready(function () {
	$.fancybox.defaults.animationEffect = "zoom-in-out";

	$(document).on("afterShow.fb", function (e, instance, slide) {
		if (MagicZoom) {
			$(".mz-zoom-window").remove();
			MagicZoom.refresh();
		}
	});

	/*
	EventBus.subscribe("add_items:insales:cart", function(cart) {
	  $.fancybox.open({
		 src: "#cart-add", // Source of the content
		 type: "inline"
	  });
	});
 */
	$(document).on("click", ".added-close", function (event) {
		event.preventDefault();
		$.fancybox.close();
	});

	$(document).on("click", ".js-modal", function (event) {
		event.preventDefault();

		$.fancybox.open({
			src: $(this).attr("href"), // Source of the content
			type: "inline",
		});
	});

	$(document).on("click", "[data-open-mobile-menu]", function (event) {
		event.preventDefault();
		alertify.panel({
			target: ".mobile_menu",
			position: "left",
		});
	});

	$('[name="phone"]').inputmask("+7(999) 999 9999");

	// Фикс для заказа в один клик
	$(document).on("click", "[data-quick-checkout]", function (event) {
		$.fancybox.close();
	});

	$(document).on("click", "[data-cart-quick]", function (event) {
		event.preventDefault();
		Cart.quickCheckout.openModal($("#insales-quick-checkout-dialog"));
	});

	$(document).on(
		"click",
		".template-cart button.m-modal-button.m-modal-button--checkout.button--checkout",
		function (event) {
			event.preventDefault();
			event.stopPropagation();

			Cart.quickCheckout._send();
		}
	);
});

/**
 * PRODUCT_INFO
 */
/*
 $(document).ready(function() {
 
	Products.setConfig({
	  initOption: true,
	  filtered: false,
	  showVariants: true,
	  useMax: false,
	  decimal: {
		 kgm: 1,
		 dmt: 1
	  },
	  fileUrl: typeof fileUrl == "undefined" ? {} : fileUrl,
	  options: {
		 Цвет: "option-image",
		 default: "option-select"
	  }
	});
 
 
	window.myVariants = new VariantsModifier({
	  updateVariant: function(data, $form) {
		 //console.log(data);
	  },
	  selectors: {
		 oldPrice: "[data-product-old-price]",
		 price: "[data-product-price]",
		 sku: "[data-product-sku]",
		 quantity: "[data-quantity-message]",
		 available: "[data-product-available]"
	  },
	  templates: {
		 price: "%s%",
		 oldPrice: "%s%",
		 emptyOldPrice: "",
		 sku: "арт. %s%",
		 emptySku: "",
		 available: "Есть в наличии",
		 notAvailable: "Нет в наличии",
		 quantityEnds: "Заканчивается",
		 quantityAlot: "Много",
		 quantityNotAvailable: "Нет в наличии"
	  },
	  productGallery: null, // Слайдер с изображениями товара
	  quantityEnds: 10, // граница между заканчивается и много
	  initVariantImage: false, // Выбор слайда при инициализации?
	  updateVariantFromSlider: false, // Обновлять вариант при перелистывании слайдов
	  useToggleOldPrice: true, // использовать show/hide на old price?
	  useToggleSku: true, // использовать show/hide на sku?
	  checkQuantityVariant: true, // проверять остаток варианта? Иначе продукта.
	  quantityNull: "quantityAlot" // Если кол-во не заполнено quantityEnds/quantityAlot/quantityNotAvailable
	});
	  
 });
 */
/**
 * PRODUCT_TABS
 */
$(document).ready(function () {
	$(".js-tabs").dataTabs({
		state: "tab", // роль плагина tab/accordion
		event: "click",
		activeIndex: 1, // активный элемент
		speedSwitching: 5000, // скорость авто переключения
		useToggle: false, // Скрытие активных вкладок
		autoSwitching: false, // авто переключение
		hideOnClosest: false, // hide on closest
		hideOnMouseout: false, // hide on Mouseout
		prevent: true, // preventDefault
		debug: false, // дебагер
		useHash: true, // использовать window.location.hash
		useJqMethods: true, // использовать jq методы анимаций?
		loop: false, // замкнуть цикл при переключении?
		initOpenTab: true, // инициализировать активный таб?
		pauseVideoAudio: true, // ставить на паузу аудио и видео при переключении табов?
		mouseoutTimeOut: false, // таймаут после снятия курсора
		jqMethodOpenSpeed: 300, // скорость открытия табы
		jqMethodOpen: "fadeIn", // jq метод открытия табы
		jqMethodCloseSpeed: 0, // скорость закрытия табы
		jqMethodClose: "hide", // jq метод закрытия табы
		onInit: function () {}, // плагин инициализировался (onInit)
		onTab: function () {}, // переключили таб (self)
		onMouseover: function () {}, // навели на блок табов (event, self)
		onMouseout: function () {}, // убрали курсор с блока табов (event, self)
	});
});

/**
 * PRODUCT-GALLERY
 */
var mzMobileOptions = {
	zoomMode: "off",
};
var mzOptions = {
	zoomDistance: 0,
	expand: "window",
	rightClick: "true",
	hint: "off",
};
$(document).ready(function () {
	if ($(window).width() > 1024) {
		$(".js-product-gallery-main .swiper-slide").addClass("swiper-no-swiping");
	}
	var $galleryThumbs = ".gallery-wrapper .js-gallery-thumbs";
	var $galleryMain = ".gallery-wrapper .js-product-gallery-main";
	galleryInit($galleryThumbs, $galleryMain);
});

function galleryInit(galleryThumbs, galleryMain) {
	var $galleryThumbs = $(galleryThumbs);
	var $galleryMain = $(galleryMain);

	var galleryThumbsSlider = new Swiper(galleryThumbs, {
		loopedSlides: $(galleryThumbs + " .swiper-wrapper .swiper-slide").length,
		spaceBetween: 30,
		navigation: {
			nextEl: ".swiper-button-next.is-thumb",
			prevEl: ".swiper-button-prev.is-thumb",
		},
		speed: 200,
		loop: false,
		slidesPerView: 3,
		touchRatio: 0.2,
		slideToClickedSlide: true,
	});

	var galleryTop = new Swiper(galleryMain, {
		loopedSlides: $(galleryMain + " .swiper-wrapper .swiper-slide").length,
		navigation: {
			nextEl: ".swiper-button-next.is-gallery",
			prevEl: ".swiper-button-prev.is-gallery",
		},
		speed: 200,
		loop: false,
		spaceBetween: 0,
	});

	galleryTop.on("transitionEnd", function (e) {
		$(".js-gallery-trigger").removeClass("is-active");
		$(".js-gallery-trigger").eq(galleryTop.activeIndex).addClass("is-active");
		if ($galleryThumbs[0] && $galleryThumbs[0].swiper)
			$galleryThumbs[0].swiper.slideTo(galleryTop.activeIndex);
	});

	galleryTop.params.control = galleryThumbsSlider;
	galleryThumbsSlider.params.control = galleryTop;

	$galleryThumbs.find(".js-gallery-trigger:first").addClass("is-active");
	$(document).on(
		"click",
		galleryThumbs + " .js-gallery-trigger",
		function (event) {
			event.preventDefault();
			var index = $(this).index();
			if ($galleryMain[0] && $galleryMain[0].swiper) {
				$galleryMain[0].swiper.slideTo(index);
			}
		}
	);
}

/**
 * PRODUCTS_SLIDER
 */
$(document).ready(function () {
	InitSwiper($(".js-products-slider").not(".products-is-hits"), {
		roundLengths: true,
		autoLength: true, // автоматически выставить кол-во слайдов исходя из минимальной ширины карточки
		minCartWidth: 280, // Минимальная ширина карточки
		autoResponsive: false, // Автоматически расчитать респонсив для слайдера
	});
});

function generateUUID() {
	var d = new Date().getTime();
	var uuid = "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function (c) {
		var r = (d + Math.random() * 16) % 16 | 0;
		d = Math.floor(d / 16);
		return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
	});
	return uuid;
}

/**
 * PROMO
 */
$(document).ready(function () {
	var sliders = InitSwiper($(".promo-slider"));
});

/**
 * QUICK_VIEW
 */
/*
$(document).ready(function () {
	$(document).on("click", "[data-quick-view]", function (event) {
		event.preventDefault();
		var _id = $(this).data("quick-view");
		Products.get(_id).done(function (product) {
			$(".js-quick_view").html(
				templateLodashRender(convertProperties(product), "quick_view")
			);

			Products.initInstance($(".js-quick_view [data-product-id]"));
			Favorite.checkFavoritesProducts();
			var $galleryThumbs = ".quick_view .js-gallery-thumbs";
			var $galleryMain = ".quick_view .js-product-gallery-main";

			MagicZoom.refresh();

			$.fancybox.open({
				src: "#quick-view", // Source of the content
				type: "inline",
			});

			galleryInit($galleryThumbs, $galleryMain);
		});
	});
});
 
var convertProperties = function (_product) {
	_product.parameters = {};
	_product.sale = null;

	// Пермалинк параметра: массив характеристик
	$.each(_product.properties, function (index, property) {
		$.each(_product.characteristics, function (index, characteristic) {
			if (property.id === characteristic.property_id) {
				setParam(_product.parameters, property.permalink, property);
				setParam(
					_product.parameters[property.permalink],
					"characteristics",
					[]
				);

				var uniq = true;
				$.each(
					_product.parameters[property.permalink].characteristics,
					function (index, cha) {
						if (cha.id == characteristic.id) {
							uniq = false;
						}
					}
				);
				if (uniq) {
					_product.parameters[property.permalink].characteristics.push(
						characteristic
					);
				}
			}
		});
	});

	// Скидка в процентах
	if (_product.variants) {
		$.each(_product.variants, function (index, variant) {
			if (variant.old_price) {
				var _merge = Math.round(
					((parseInt(variant.old_price) - parseInt(variant.price)) /
						parseInt(variant.old_price)) *
						100,
					0
				);
				if (_merge < 100) {
					_product.sale = _merge;
				}
			}
		});
	}

	function setParam(obj, name, value) {
		obj[name] || (obj[name] = value);
	}

	return _product;
};
 
$(document).ready(function () {
	var $recently_view = $(".js-recently_view");
	if ($recently_view.length > 0) {
		var myRecentlyView = new RecentlyView({
			success: function (_products) {
				if (_.size(_products) > 0) {
					var _templateRecentlyView = _.template(
						$('[data-template-id="recently_view"]').html()
					);
					$recently_view.html(_templateRecentlyView({ products: _products }));

					InitSwiper(".js-recently-slider", {
						autoLength: true,
						minCartWidth: 300,
						//maxBreakpoint: 1920,
						autoResponsive: false,
					});

					// Инициализация data-product-id
					Products.getList(_.map(_products, "id"));
				}
			},
		});
	}
});
*/
/**
 * SCRIPTS
 */
$(document).ready(function () {
	$("body").addClass("dom-ready");

	$(window).on("load", function (event) {
		$("body").addClass("window-load");
	});

	var elements = $(".sticky");
	Stickyfill.add(elements);
});

/**
 * SCROLL_TOP
 */
$(document).ready(function () {
	var scroll_top = new DetectiveScroll({
		trigger: {
			el: $(".js-scroll_top"),
			scroll: $(window).height() / 3,
		},
	});

	$(document).on("click", ".js-scroll_top", function (event) {
		event.preventDefault();
		window.scroll({ top: 0, left: 0, behavior: "smooth" });
	});
});

/**
 * HELP
 */
function deleteAllCookies() {
	var cookies = document.cookie.split(";");
	for (var i = 0; i < cookies.length; i++) {
		var spcook = cookies[i].split("=");
		deleteCookie(spcook[0]);
	}
	function deleteCookie(cookiename) {
		var d = new Date();
		d.setDate(d.getDate() - 1);
		var expires = ";expires=" + d;
		var name = cookiename;
		//alert(name);
		var value = "";
		document.cookie = name + "=" + value + expires + "; path=/acc/html";
	}
	window.location = ""; // TO REFRESH THE PAGE
}

$(document).ready(function () {
	$(document).on("click", "[data-clear-cookies]", function (event) {
		event.preventDefault();
		deleteAllCookies();

		alertify.success("Куки очищены", 4);
	});
	$(document).on("click", "[data-clear-localforage]", function (event) {
		event.preventDefault();
		localforage.clear();

		alertify.success("localforage очищен", 4);
		window.location = ""; // TO REFRESH THE PAGE
	});
	$(document).on("click", "[data-clear-cart]", function (event) {
		event.preventDefault();
		Cart.clear();

		setTimeout(function () {
			alertify.success("Корзина очищена", 4);
			window.location = ""; // TO REFRESH THE PAGE
		}, 3000);
	});
});

/**
 * STYLE_GUIDE
 */
$(document).ready(function () {
	$(".js-style_tabs").dataTabs({
		state: "accordion",
	});
	$("[data-alert-success]").click(function (event) {
		alertify.success("Товар добавлен в корзину", 10);
	});
	$("[data-alert-error]").click(function (event) {
		alertify.error("Ошибка при отправке формы", 10);
	});
	$("[data-alert-warning]").click(function (event) {
		alertify.warning("Товар удален", 10);
	});
	$("[data-alert-message]").click(function (event) {
		alertify.message("Все поля обязательны для заполнения", 10);
	});

	$(".js-fav-style").click(function (event) {
		event.preventDefault();

		$(this).toggleClass("not-added is-added");
	});
});
/*
function templateLodashRender(content, templateId) {
	var templateContent = $('[data-template-id="' + templateId + '"]').html();
	var renderContent = _.template(templateContent);

	return renderContent(content);
}

function getDiscount(price, old_price) {
	var sale = "";
	var _merge = Math.round(
		((parseInt(old_price) - parseInt(price)) / parseInt(old_price)) * 100,
		0
	);
	if (_merge < 100) {
		sale =
			'<div class="stiker stiker-sale">' +
			"<span>" +
			"скидка " +
			_merge +
			"%" +
			"</span>" +
			"</div>";
	}

	return sale;
}

function getStiker(name, characteristics) {
	var labels_list = "";
	_.forEach(characteristics, function (characteristic) {
		if (
			characteristic.permalink == name ||
			(characteristic.property
				? characteristic.property.permalink == name
				: false)
		) {
			labels_list += '<div class="stiker stiker-';
			labels_list += characteristic.permalink;
			labels_list += '"><span>';
			labels_list += characteristic.title;
			labels_list += "</span></div>";
		}
	});

	return labels_list;
}
*/
/**
 * CATEGORY
 */
$(document).ready(function () {
	$(".category_menu-item[data-tabs-container]").dataTabs({
		state: "accordion",
		useJqMethods: false,
	});
});

/**
 * Object-fit hack
 */
(function () {
	var isSupports = "object-fit" in document.body.style;

	if (isSupports) {
		return;
	}

	$(".image-container.is-cover").each(function () {
		var $container = $(this),
			imgUrl = $container.find("img").prop("src");
		if (imgUrl) {
			$container
				.css("backgroundImage", "url(" + imgUrl + ")")
				.addClass("with-trick");
		}
	});
})();

$(function () {
	$("body").addClass("dom-ready");
});

$(".search_widget-control").focus(function () {
	$(this).parents(".search_widget").addClass("active");
});

$(".search_widget-control").focusout(function () {
	$(this).parents(".search_widget").removeClass("active");
});

var bestseller = new Swiper(".swiper-container.bestseller", {
	loop: true,
	slidesPerView: 3,
	spaceBetween: 10,
	navigation: {
		nextEl: ".bestseller-button-next",
		prevEl: ".bestseller-button-prev",
	},
	lazy: true,

	on: {
		init: function () {
			$(".bestseller").css({
				opacity: "1",
				visibility: "visible",
			});
			$(".bestseller-wrap .navigation").css({
				opacity: "1",
				visibility: "visible",
			});
		},
	},
	breakpoints: {
		700: {
			slidesPerView: 2,
		},
		480: {
			slidesPerView: 1,
		},
	},
});
var scrollPos = 0;

var Visible = function (target) {
	var st = window.pageYOffset;

	// Все позиции элемента
	var targetPosition = {
			top: window.pageYOffset + target.getBoundingClientRect().top,
			left: window.pageXOffset + target.getBoundingClientRect().left,
			right: window.pageXOffset + target.getBoundingClientRect().right,
			bottom: window.pageYOffset + target.getBoundingClientRect().bottom,
		},
		// Получаем позиции окна
		windowPosition = {
			top: window.pageYOffset,
			left: window.pageXOffset,
			right: window.pageXOffset + document.documentElement.clientWidth,
			bottom: window.pageYOffset + document.documentElement.clientHeight,
		};

	if (targetPosition.top + 100 < windowPosition.bottom) {
		$(target).addClass("active-scroll");
	} else {
		// Если элемент не видно, то запускаем этот код
		$(target).removeClass("active-scroll");
	}

	scrollPos = st;
};
var element = document.querySelector(".yacht .absolute-wrap");
if ($(element).length) {
	Visible(element);
	window.addEventListener("scroll", function () {
		Visible(element);
	});
}

var elementCh = document.querySelector("[data-chevron]");
if ($(elementCh).length) {
	Visible(elementCh);
	window.addEventListener("scroll", function () {
		Visible(elementCh);
	});
}

var barfixed = document.querySelector("[data-fixed-bar]");
if ($(barfixed).length) {
	Visible(barfixed);
	window.addEventListener("scroll", function () {
		Visible(barfixed);
	});
}

var fixed_header = document.querySelector(".fixed_header");
if ($(fixed_header).length) {
	window.addEventListener("scroll", function () {
		var top = window.pageYOffset;
		var height = $(".fixed_header").innerHeight();
		if (top >= height + 100) {
			$(".fixed_header").addClass("is-enabled");
		} else {
			$(".fixed_header").removeClass("is-enabled");
		}
	});
}

var menu = document.querySelector("[data-scroll-menu]");
if ($(menu).length) {
	window.addEventListener("scroll", function () {
		var top = window.pageYOffset;
		if (top >= 200) {
			$("[data-scroll-menu]").addClass("active");
		} else {
			$("[data-scroll-menu]").removeClass("active");
		}
	});
}

$("[data-tabs-control]").click(function () {
	$("[data-tabs-control]").removeClass("active");
	$("[data-tabs-content]").removeClass("active");
	$(this).addClass("active");
	var handle = $(this).data("tabs-control");
	$('[data-tabs-content="' + handle + '"]').addClass("active");
});

var best = new Swiper(".best-slider", {
	loop: true,
	slidesPerView: 4,
	spaceBetween: 20,
	lazy: true,
	breakpoints: {
		1300: {
			slidesPerView: 3,
		},
		920: {
			slidesPerView: 2,
		},
		700: {
			slidesPerView: 1,
		},
	},

	on: {
		init: function () {
			$(".best-slider").css({
				opacity: "1",
				visibility: "visible",
			});
		},
	},
});

$("[data-nav-custom]").click(function () {
	var direction = $(this).data("nav-custom");
	var count = $("[data-count].active").data("count");
	if (direction == "next") {
		best[count].slideNext();
	}
	if (direction == "prev") {
		best[count].slidePrev();
	}
});

$(document).on("click", "[data-nav-custom2]", function () {
	var direction = $(this).data("nav-custom2");
	var count = window.ajax_slider.activeIndex;
	if (direction == "next") {
		mySwiperN[count].slideNext();
	}
	if (direction == "prev") {
		mySwiperN[count].slidePrev();
	}
});

var alertify = {};
alertify.success = function (text) {
	$(".removeTocard").removeClass("active");
	$(".addTofavorite").addClass("active");
	setTimeout(function () {
		$(".addTofavorite").removeClass("active");
	}, 2000);
};
alertify.error = function (text) {
	$(".addTofavorite").removeClass("active");
	$(".removeTocard").addClass("active");
	setTimeout(function () {
		$(".removeTocard").removeClass("active");
	}, 2000);
};

/**
 * FAVORITE
 */
/*
			 var Favorite = {};
			 $(document).ready(function() {
				 window.Favorite = new Favorites({
					  counterTemplate: "%c%",
					  //buttonNotAddedText: 'Добавить в избранное',
					  //buttonAddedText: 'Удалить из избранного',
					  onAdd: function(data) {
							data.$target.find('use').attr('xlink:href', '#addFavorite');
							alertify.success("Товар добавлен в избранное");
					  },
					  onRemove: function(data) {
							data.$target.find('use').attr('xlink:href', '#heart');
							alertify.error("Товар удален из избранного");
					  },
					  onUpdate: function(data) {
					// console.log(data)
							var counter = 0;
							for (var key in data.products) {
			
								 $('[data-favorites-trigger="' + key + '"]').find('use').attr('xlink:href', '#addFavorite');
								 counter++;
							}
							if (counter) {
								 $('[data-favorite-link]').find('use').attr('xlink:href', '#addFavorite')
							}
			
							var isFavoritePage = $(".js-favorite").length > 0;
							if (isFavoritePage) {
								 // Рендер списка
								 $(".js-favorite").html(Template.render(data, "favorite"));
			
								 // инициализация инстансов нужна после динамического добавления товаров
								 Products.getList(_.map(data.products, "id"));
								 Favorite.checkFavoritesProducts();
								 var counter = 0;
								 for (var key in data.products) {
									  $('[data-favorites-trigger="' + key + '"]').find('use').attr('xlink:href', '#addFavorite');
									  counter++;
								 }
								 if (counter) {
									  $('[data-favorite-link]').find('use').attr('xlink:href', '#addFavorite')
								 }
							}
					  }
				 });
			});
		 

function getDiscount(price, old_price) {
	var sale = "";
	var _merge = Math.round(
		((parseInt(old_price) - parseInt(price)) / parseInt(old_price)) * 100,
		0
	);
	if (_merge < 100) {
		sale =
			'<div class="stiker stiker-sale">' +
			"<span>" +
			"скидка " +
			_merge +
			"%" +
			"</span>" +
			"</div>";
	}

	return sale;
}

function getStiker(name, characteristics) {
	var labels_list = "";
	_.forEach(characteristics, function (characteristic) {
		if (
			characteristic.permalink == name ||
			(characteristic.property
				? characteristic.property.permalink == name
				: false)
		) {
			labels_list += '<div class="stiker stiker-';
			labels_list += characteristic.permalink;
			labels_list += '"><span>';
			labels_list += characteristic.title;
			labels_list += "</span></div>";
		}
	});

	return labels_list;
}


			EventBus.subscribe("update_items:insales:cart:light", function(cart) {
			
				 $('.cart-count').text(cart.items_count);
				 $('[data-total-cart-price]').text(Shop.money.format(cart.total_price))
				 ChangeMoney(cart.total_price);
			
				 if (cart.items_count == 0) {
					  $('[data-empty-cart]').remove();
					  $('[data-empty-cart-notice]').show('slow');
					  $('[data-cart-wrap]').addClass('cell-12');
					  $('.cart-form').addClass('padding-custom')
				 }
			})
			*/

$(document).on("click", "[data-ajax-kits-add]", function (e) {
	e.preventDefault();
	console.log("testsssss");
	var obj = $(this)
		.parents("form")
		.find("[data-bundle-items]")
		.data("bundle-items");
	$.post("/cart_items.json", {
		variant_ids: obj,
	}).done(function (cart) {
		$(".cart-count").text(cart.items_count);
		$("[data-total-cart-price]").text(Shop.money.format(cart.total_price));
		$(".addModal").addClass("add");
		ChangeMoney(cart.total_price);
	});
});

$("[data-item-delete]").click(function () {
	$(this).parents(".cart-item").slideUp("slow");
});

function appendBundle_complect(products) {
	function makeCounter() {
		var currentCount = 0;
		return function () {
			return currentCount++;
		};
	}

	var counter = makeCounter();

	/*
	let products_html = `<div class="swiper-container" data-ajax-slider><div class="swiper-wrapper">`;


	$(products).each(function (i, item) {
		products_html += `
			<div class="swiper-slide"> 
			<form class="card-kits" action="/cart_items" method="post" data-product-id="${item.id}"> 
				<div class="content">
					<div class="row top">
					<div class="card-title">
						${item.title}
					</div>
					<div class="count">Products included: <span data-count-super></span></div>
					</div> 
					<div data-bundle-complect="${item.id}" class="bundle-complect"></div>
				</div> 
				<div class="blue-action"> 
					<input type="hidden" name="quantity" value="1" />
					<input type="hidden" name="variant_id" value="<%= product.variants[0].id %>">
					<a href="<%= product.url %>" class="show-p">more</a>
					<a href="<%= product.url %>" class="bttn-blue" data-item-add>
					<div>
						<%= Shop.money.format(product.variants[0].price) %>
					</div> 
					<svg class="icon">
						<use xlink:href="#basket"></use>
					</svg>
					</a>
					<button type="button" title="Избранное" class="bttn-favorite" data-favorites-trigger="${item.id}">
					<svg class="icon">
						<use xlink:href="#heart"></use>
					</svg>
					<span class="bttn-favorite-inner is-1"></span>
					<span class="bttn-favorite-inner is-2"></span>
					<span class="bttn-favorite-inner is-3"></span>
					</button>
				</div>
			</form> 
			</div>
		`;
	});

	products_html += ` </div>
                  <div class="swiper-button-prev super-button-prev" data-nav-custom2="prev">
                      <svg class="icon">
                          <use xlink:href="#swiper-prev"></use>
                      </svg>
                  </div>
                  <div class="swiper-button-next super-button-next" data-nav-custom2="next">
                      <svg class="icon">
                          <use xlink:href="#swiper-next"></use>
                      </svg>
                  </div>
             </div>`;
				 */

	window.mySwiperN = new Swiper(".new-super-slider", {
		slidesPerView: 3,
		slidesPerColumn: 2,
		spaceBetween: 20,
		breakpoints: {
			768: {
				slidesPerView: 2,
			},
		},
		on: {
			init: function () {
				console.log("swiper init");
				$("[data-ajax-slider-place]").css("opacity", "1");
				$(".height-slider").css("background", "#fff");
			},
		},
	});

	/*

	Products.getList(product_ids)
		.done(function (onDone) {
			for (var prop in onDone) {
				var bundle_products_id = [];
				var bundle_variant_id = [];
				var bundle_variants_id_quan = {};
				var bundle = onDone[prop].product_bundle_components;
				var count = 0;
				var total_bundle_items_size = 0;

				for (var i = 0; i < bundle.length; i++) {
					var key = String(bundle[i].variant_id);
					bundle_variants_id_quan[key] = bundle[i].quantity;
					total_bundle_items_size += Number(bundle[i].quantity);
					bundle_products_id.push(bundle[i].product_id);
					bundle_variant_id.push(bundle[i].variant_id);
				}

				var str = bundle_products_id.join(",");
				(function (
					str,
					bundle_products_id,
					bundle_variant_id,
					product_ids,
					count,
					total_bundle_items_size,
					bundle_variants_id_quan
				) {
					var vid = bundle_variant_id[count];
					var a = "?lang=ru"; // +Shop.config.config.locale;
					$.getJSON("/products_by_id/" + str + ".json" + a).done(function (
						resronce
					) {
						var Total_items_bindle_price_sum = 0;
						for (var i = 0; i < resronce.products.length; i++) {
							for (var b = 0; b < resronce.products[i].variants.length; b++) {
								var v_id = resronce.products[i].variants[b].id;
								for (var key in bundle_variants_id_quan) {
									if (key == v_id) {
										Total_items_bindle_price_sum +=
											bundle_variants_id_quan[key] *
											resronce.products[i].variants[b].price;
									}
								}
							}
						}

						var onDone2 = resronce.products;
						var tmp = _.template($("[data-template-micro]").html());

						setTimeout(function () {
							window.mySwiperN = new Swiper(".new-super-slider", {
								slidesPerView: 3,
								slidesPerColumn: 2,
								spaceBetween: 20,
								breakpoints: {
									768: {
										slidesPerView: 2,
									},
								},
								on: {
									init: function () {
										$("[data-ajax-slider-place]").css("opacity", "1");
										$(".height-slider").css("background", "#fff");
									},
								},
							});
						}, 10);

						for (var i = 0; i < onDone2.length; i++) {
							onDone2[i].vid = bundle_variant_id[i];
						}

						$('[data-bundle-complect="' + product_ids[count] + '"]').html(
							tmp(onDone2)
						);

						function setLinkParam(link, key, value) {
							let result = link;
							let isHttpLink = /(http|https):\/\//g.test(link);
							let path = _.chain(link).split("/").compact().join("/").value();
							let new_link = isHttpLink
								? link
								: window.location.origin +
								  (_.includes(link, "/") ? "" : window.location.pathname) +
								  "/" +
								  path;

							let parseURL = new URL(new_link);
							if (
								parseURL.origin &&
								parseURL.host == window.location.host &&
								!/:/g.test(parseURL.pathname)
							) {
								parseURL.searchParams.set(key, value);
								if (isHttpLink) {
									result = parseURL.toString();
								} else {
									result = _.replace(
										parseURL.toString(),
										window.location.origin,
										""
									);
								}
							}

							return result;
						}

						function getLinkCurrentLang(link) {
							if (_.isString(link) && Tools.url.keys["lang"]) {
								return setLinkParam(link, "lang", Tools.url.keys["lang"]);
							} else {
								return link;
							}
						}
						$(".kits-wrap a").each(function (index, el) {
							let link = $(this).attr("href");
							let langLink = getLinkCurrentLang(link);
							$(this).attr("href", langLink);
						});

						$('[data-bundle-complect="' + product_ids[count] + '"]')
							.parents(".card-kits")
							.find("[data-count-super]")
							.text(total_bundle_items_size);
						$('[data-bundle-complect="' + product_ids[count] + '"]').attr(
							"data-bundle-items",
							JSON.stringify(bundle_variants_id_quan)
						);

						$('[data-bundle-complect="' + product_ids[count] + '"]')
							.parents(".card-kits")
							.find("[data-item-add] span")
							.text(Shop.money.format(Total_items_bindle_price_sum));

						$('[data-bundle-complect="' + product_ids[count] + '"]')
							.parents(".card-kits")
							.find("[data-item-add]")
							.attr("data-ajax-kits-add", "add")
							.removeAttr("data-item-add");

						if (count == 0) {
							window.ajax_slider = new Swiper("[data-ajax-slider]", {
								slidesPerView: 1,

								loop: true,
								speed: 600,
								autoHeight: true,
								centeredSlides: true,
							});
						}
					});
				})(
					str,
					bundle_products_id,
					bundle_variant_id,
					product_ids,
					counter(),
					total_bundle_items_size,
					bundle_variants_id_quan
				);
			}
		})
		.fail(function (onFail) {
			// console.log('onFail', onFail)
		});
		*/
}

/*
function appendBundle_complect(products) {
	function makeCounter() {
		var currentCount = 0;

		return function () {
			return currentCount++;
		};
	}

	var counter = makeCounter();

	var product_ids = [];

	products.forEach(function (item, i, arr) {
		product_ids.push(products[i].id);
	});

	Products.getList(product_ids)
		.done(function (onDone) {
			for (var prop in onDone) {
				var bundle_products_id = [];
				var bundle_variant_id = [];
				var bundle_variants_id_quan = {};
				var bundle = onDone[prop].product_bundle_components;
				var count = 0;
				var total_bundle_items_size = 0;

				for (var i = 0; i < bundle.length; i++) {
					var key = String(bundle[i].variant_id);
					bundle_variants_id_quan[key] = bundle[i].quantity;
					total_bundle_items_size += Number(bundle[i].quantity);
					bundle_products_id.push(bundle[i].product_id);
					bundle_variant_id.push(bundle[i].variant_id);
				}

				var str = bundle_products_id.join(",");
				(function (
					str,
					bundle_products_id,
					bundle_variant_id,
					product_ids,
					count,
					total_bundle_items_size,
					bundle_variants_id_quan
				) {
					var vid = bundle_variant_id[count];
					var a = "?lang=ru"; // +Shop.config.config.locale;
					$.getJSON("/products_by_id/" + str + ".json" + a).done(function (
						resronce
					) {
						var Total_items_bindle_price_sum = 0;
						for (var i = 0; i < resronce.products.length; i++) {
							for (var b = 0; b < resronce.products[i].variants.length; b++) {
								var v_id = resronce.products[i].variants[b].id;
								for (var key in bundle_variants_id_quan) {
									if (key == v_id) {
										Total_items_bindle_price_sum +=
											bundle_variants_id_quan[key] *
											resronce.products[i].variants[b].price;
									}
								}
							}
						}

						var onDone2 = resronce.products;
						var tmp = _.template($("[data-template-micro]").html());

						setTimeout(function () {
							window.mySwiperN = new Swiper(".new-super-slider", {
								slidesPerView: 3,
								slidesPerColumn: 2,
								spaceBetween: 20,
								breakpoints: {
									768: {
										slidesPerView: 2,
									},
								},
								on: {
									init: function () {
										$("[data-ajax-slider-place]").css("opacity", "1");
										$(".height-slider").css("background", "#fff");
									},
								},
							});
						}, 10);

						for (var i = 0; i < onDone2.length; i++) {
							onDone2[i].vid = bundle_variant_id[i];
						}

						$('[data-bundle-complect="' + product_ids[count] + '"]').html(
							tmp(onDone2)
						);

						function setLinkParam(link, key, value) {
							let result = link;
							let isHttpLink = /(http|https):\/\//g.test(link);
							let path = _.chain(link).split("/").compact().join("/").value();
							let new_link = isHttpLink
								? link
								: window.location.origin +
								  (_.includes(link, "/") ? "" : window.location.pathname) +
								  "/" +
								  path;

							let parseURL = new URL(new_link);
							if (
								parseURL.origin &&
								parseURL.host == window.location.host &&
								!/:/g.test(parseURL.pathname)
							) {
								parseURL.searchParams.set(key, value);
								if (isHttpLink) {
									result = parseURL.toString();
								} else {
									result = _.replace(
										parseURL.toString(),
										window.location.origin,
										""
									);
								}
							}

							return result;
						}

						function getLinkCurrentLang(link) {
							if (_.isString(link) && Tools.url.keys["lang"]) {
								return setLinkParam(link, "lang", Tools.url.keys["lang"]);
							} else {
								return link;
							}
						}
						$(".kits-wrap a").each(function (index, el) {
							let link = $(this).attr("href");
							let langLink = getLinkCurrentLang(link);
							$(this).attr("href", langLink);
						});

						$('[data-bundle-complect="' + product_ids[count] + '"]')
							.parents(".card-kits")
							.find("[data-count-super]")
							.text(total_bundle_items_size);
						$('[data-bundle-complect="' + product_ids[count] + '"]').attr(
							"data-bundle-items",
							JSON.stringify(bundle_variants_id_quan)
						);

						$('[data-bundle-complect="' + product_ids[count] + '"]')
							.parents(".card-kits")
							.find("[data-item-add] span")
							.text(Shop.money.format(Total_items_bindle_price_sum));

						$('[data-bundle-complect="' + product_ids[count] + '"]')
							.parents(".card-kits")
							.find("[data-item-add]")
							.attr("data-ajax-kits-add", "add")
							.removeAttr("data-item-add");

						if (count == 0) {
							window.ajax_slider = new Swiper("[data-ajax-slider]", {
								slidesPerView: 1,

								loop: true,
								speed: 600,
								autoHeight: true,
								centeredSlides: true,
							});
						}
					});
				})(
					str,
					bundle_products_id,
					bundle_variant_id,
					product_ids,
					counter(),
					total_bundle_items_size,
					bundle_variants_id_quan
				);
			}
		})
		.fail(function (onFail) {
			// console.log('onFail', onFail)
		});
}
*/

$(document).on("click", ".next-kits", function () {
	ajax_slider.slideNext();
});

$(document).on("click", ".prev-kits", function () {
	ajax_slider.slidePrev();
});

$(function () {
	$("[data-handle]").dblclick(function (e) {
		e.stopPropagation();
		e.preventDefault();
	});

	$("[data-handle]").click(function (e) {
		e.preventDefault();
		const handle = $(this).attr("data-handle");
		const tag = $(this).attr("data-tag");
		if (!$(this).hasClass("l2")) {
			$("[data-handle]").removeClass("active");
			$(this).addClass("active");
			$(".subcol-kits").removeClass("active");
			$(this).parent().find(".subcol-kits").addClass("active");
			$(".subcol-kits").not(".active").hide("slow");
			$(this).parent().find(".subcol-kits").show("slow");
		} else {
			$(".subcol-kits li").removeClass("active");
			$(this).addClass("active");
		}

		$("[data-ajax-slider-place]").css("opacity", "0");
		//console.log(handle);

		$("[data-ajax-slider-place]").load(
			handle + "?view=empty",
			function (response, status, xhr) {
				$("[data-ajax-slider-place]").css("opacity", "1");
				$(".height-slider").css("background", "#fff");
				window.mySwiperN = new Swiper(".new-super-slider", {
					slidesPerView: 3,
					slidesPerColumn: 2,
					spaceBetween: 20,
					breakpoints: {
						768: {
							slidesPerView: 2,
						},
					},
					on: {
						init: function () {
							$("[data-ajax-slider-place]").css("opacity", "1");
							$(".height-slider").css("background", "#fff");
						},
					},
				});
				wishlistApp.init();
				smartsetBuy.init();

				if (status == "error") {
					console.log(
						"Ошибка при загрузке: " + xhr.status + " " + xhr.statusText
					);
				}
			}
		);

		/*
		function filterByTag(products, tag) {
			return products.filter((product) => product.tags.includes(tag));
		}







		fetch(handle + "/products.json")
			.then((response) => response.json())
			.then((data) => {
				console.log(data);
				const products = data.products;

				let filteredProducts = filterByTag(products, tag);
				console.log(filteredProducts);
				appendBundle_complect(filteredProducts);
			})
			.catch((error) => console.error("Error:", error));
			*/
	});
});

$(".search-collections").click(function () {
	$(".search-collections").toggleClass("active");
	$(".search_widget").toggleClass("no-border-radius");
	$(".drop-search").toggle("slow");
});

function search_collection(e, self) {
	e.preventDefault();
	$("[data-search-collection]").removeClass("active");
	$(self).addClass("active");
	if (~location.href.indexOf("?lang=en")) {
		var a = "Searching goods ";
	} else {
		var a = "Поиск товаров ";
	}
	$("[data-search-field]").attr(
		"placeholder",
		a + $(self).text().toLowerCase()
	);
	$(".search-collections span").text($(self).text());

	$(".search-form-main").attr("action", $(self).attr("href"));
}

$("[data-search-collection]").dblclick(function (e) {
	search_collection(e, this);
});

$("[data-search-collection]").click(function (e) {
	search_collection(e, this);
});

$(document).mouseup(function (e) {
	if (
		$(e.target).data("toggle-search-collection") == undefined &&
		$(e.target).parents(".search-collections").length == 0
	) {
		$(".drop-search").hide("slow");
		$(".search-collections").removeClass("active");
		$(".search_widget").removeClass("no-border-radius");
	}
});

$("[data-t-menu-catalog]").click(function () {
	$(this).toggleClass("active");
	$("[data-t-filter]").removeClass("active");
	$("[data-menu-catalog]").toggle("slow");
	$("[data-filter]").hide("slow");
});

$("[data-t-filter]").click(function () {
	$(this).toggleClass("active");
	$("[data-t-menu-catalog]").removeClass("active");
	$("[data-menu-catalog]").hide("slow");
	$("[data-filter]").toggle("slow");
});

$("[data-search-link]").click(function () {
	location.href = "/search";
});

$(document).on("click", "[data-menu-togler]", function () {
	$(".wrap-mobile-menu").toggleClass("active");
	$("body").toggleClass("active-menu");
});

/*
			EventBus.subscribe("add_items:insales:cart:light", function(cart) {
			  $(".addModal").addClass('add');
			})
			  */

/*
$(document).on("click", "[data-close-modal]", function () {
	$(".addModal").removeClass("add");
	$(".f-modal").removeClass("active");
});
*/
function getBrand(product) {
	var a = "";
	_.forEach(product.characteristics, function (characteristic) {
		if (characteristic.property_id == 24362119) {
			a = '<div class="stiker-brand">' + characteristic.title + "</div>";
		}
	});
	return a;
}

var liquid_kits = new Swiper(".liquid-kits-slider", {
	speed: 400,
	spaceBetween: 0,
	loop: true,
	autoHeight: true,
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
});

$(".next-kits-liq").click(function () {
	liquid_kits.slideNext();
});

$(document).on("click", "[data-feadback-bttn]", function () {
	$(".f-modal").addClass("active");
});

$(document).mouseup(function (e) {
	if ($(e.target).hasClass("f-modal")) {
		$(".f-modal").removeClass("active");
	}
});

/*
$(document).mouseup(function (e) {
	if ($(e.target).hasClass("addModal")) {
		$(".addModal").removeClass("add");
	}
});
*/
$("[data-scroll-menu]").click(function (e) {
	e.preventDefault();
	$(this).toggleClass("cross");
	$(".hover-menu-wrap").toggleClass("active");
});

$(document).mouseup(function (e) {
	if ($(e.target).hasClass("hover-menu-wrap")) {
		$("[data-scroll-menu]").toggleClass("cross");
		$(".hover-menu-wrap").removeClass("active");
	}
});

var a = $(window).innerHeight();
var b = $(".hover-menu").innerHeight();
if (a < b) {
	$(".hover-menu").css("height", "100%");
	$(".hover-menu").addClass("scroll");
}

$("[data-hhh]").click(function (e) {
	e.preventDefault();
	var handle = $(this).data("hhh");
	$("[data-hhh]").removeClass("active");
	$(this).addClass("active");
	$("[data-hh]").removeClass("active");
	$('[data-hh="' + handle + '"]')
		.addClass("active")
		.find("[data-handle]")
		.eq(0)
		.click();
});

$(document).ready(function () {
	$("[data-hhh]").eq(0).click();
});

$(".super-quan button").click(function (e) {
	e.preventDefault();
});

function superCounter(self) {
	var parent = self.parents("[data-card-collection]");
	var total = 0;
	var old_total = 0;
	parent.find("[data-item-s]").each(function () {
		var id = $(this).data("item-s");
		var quan = Number($(this).find("[data-input]").val());
		var item = $('.item[data-item="' + id + '"]');
		console.log(item);
		var price = Number(item.find("[data-s-price]").attr("data-s-price"));
		var old = Number(item.find("[data-s-old]").attr("data-s-old"));
		console.log(price);
		if (quan > 0) {
			item.find("[data-c]").text(quan + " x ");
			item.show();
			item
				.find("[data-s-price]")
				.text(Shopify.formatMoney(price * quan, "€{{amount_no_decimals}}"));
			total += price * quan;
			old_total += old * quan;
		} else {
			item.hide();
		}
	});

	var superQuan = Number(parent.find("[data-super-quan]").val());
	parent
		.find("[data-total-s]")
		.text(Shopify.formatMoney(total * superQuan, "€{{amount_no_decimals}}"));
	parent
		.find("[data-old-total-s]")
		.text(
			Shopify.formatMoney(old_total * superQuan, "€{{amount_no_decimals}}")
		);
}

$("[data-p]").click(function () {
	var self = $(this);
	var val = Number(self.parents(".super-quan").find("input").val());
	self
		.parents(".super-quan")
		.find("input")
		.val(val + 1);
	superCounter(self);
});

$("[data-m]").click(function () {
	var self = $(this);
	var val = Number(self.parents(".super-quan").find("input").val());
	if (val != 0) {
		self
			.parents(".super-quan")
			.find("input")
			.val(val - 1);
	}
	superCounter(self);
});

$('.quan [data-quantity-change="1"]').click(function () {
	var self = $(this);
	var val = Number(self.parents("[data-s-qrap]").find("input").val());
	self
		.parents("[data-s-qrap]")
		.find("input")
		.val(val + 1);
	superCounter(self);
});
$('.quan [data-quantity-change="-1"]').click(function () {
	var self = $(this);
	var val = Number(self.parents("[data-s-qrap]").find("input").val());
	if (val != 1) {
		self
			.parents("[data-s-qrap]")
			.find("input")
			.val(val - 1);
	}
	superCounter(self);
});

/*
$("[data-super-add]").click(function () {
	var parent = $(this).parents("[data-card-collection]");
	var obj = {};
	var superQuan = Number(parent.find("[data-super-quan]").val());

	parent.find("[data-var-s]").each(function () {
		var id = $(this).data("var-s");
		var q = $(this).find("[data-input]").val();
		obj[id] = q * superQuan;
	});

	$.post("/cart_items.json", {
		variant_ids: obj,
	}).done(function (cart) {
		$(".cart-count").text(cart.items_count);
		$("[data-total-cart-price]").text(Shop.money.format(cart.total_price));
		$(".addModal").addClass("add");
	});
});
*/

function get_name_browser() {
	// получаем данные userAgent
	var ua = navigator.userAgent;
	// с помощью регулярок проверяем наличие текста,
	// соответствующие тому или иному браузеру
	if (ua.search(/Chrome/) > 0) return "Google Chrome";
	if (ua.search(/Firefox/) > 0) return "Firefox";
	if (ua.search(/Opera/) > 0) return "Opera";
	if (ua.search(/Safari/) > 0) return "Safari";
	if (ua.search(/MSIE/) > 0) return "Internet Explorer";
	// условий может быть и больше.
	// сейчас сделаны проверки только
	// для популярных браузеров
	return "Не определен";
}

// пример использования
var browser = get_name_browser();

function ChangeMoney(total_price) {
	$.getJSON("https://www.cbr-xml-daily.ru/daily_json.js").done(function (
		currency
	) {
		var euro = currency.Valute.EUR.Value;
		var ratio = euro + (euro / 100) * 2.5;
		var text = Math.round(total_price * ratio).toLocaleString("ru") + " р.";

		$("[data-total-cart-rub]").text(text);
		return ratio;
	});
}

if (window.innerWidth < 481) {
	$(document).ready(function () {
		$("[data-hh]").click(function () {
			var destination = $("[data-ajax-slider-place]").offset().top - 40;
			if (get_name_browser() === "Safari") {
				$("body").animate({ scrollTop: destination }, 1100); //1100 - скорость прокрутки
			} else {
				$("html").animate({ scrollTop: destination }, 1100);
			}
			return false;
		});

		$("[data-tabs-control]").click(function () {
			var destination = $("[data-tabs-content]").offset().top - 40;
			if (get_name_browser() === "Safari") {
				$("body").animate({ scrollTop: destination }, 1100); //1100 - скорость прокрутки
			} else {
				$("html").animate({ scrollTop: destination }, 1100);
			}
			return false;
		});
	});
}

if ($(window).innerWidth() < 1025) {
	$(".product_description .val table").each(function () {
		$(this).wrap("<div class='overflow-table'></div>");
	});
}

$(".co-basket_subtotal-list, .co-basket_total").wrapAll(
	'<div class="sticky-check">'
);

$(".co-sidebar").css("opacity", "1");

$("[data-full]").click(function () {
	$("[data-full-place]").removeClass("nofull-place");
});

$("[data-nofull]").click(function () {
	$("[data-full-place]").addClass("nofull-place");
});

var arr = [];
qick = document.querySelector("[data-quick-src]") || false;

if (qick) {
	var src = qick.dataset.quickSrc;
	arr[src] = new Image();
	arr[src].addEventListener(
		"load",
		function () {
			var style = "background-image: url(" + src + "); opacity: 1;";
			qick.setAttribute("style", style);
		},
		false
	);
	arr[src].src = src;
}

function createCookie(name, value, days = 6570) {
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		var expires = "; expires=" + date.toUTCString();
	} else var expires = "";
	document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(";");
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == " ") c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}

readCookie("acceptCookies") !== "true" && createCookie("acceptCookies", "true");
readCookie("closeCookiesPopup") !== "true" &&
	$(".cookie-popup").css("display", "block");
$(".cookie-popup button").click(function () {
	$(".cookie-popup").slideUp();
	createCookie("closeCookiesPopup", "true");
});

/*
let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

function addToWishlist(productId) {
	if (wishlist.includes(productId)) {
		alert("Этот товар уже в вашем Wishlist!");
		return;
	}
	wishlist.push(productId);
	localStorage.setItem("wishlist", JSON.stringify(wishlist));
	updateButtonState(productId, true);
	renderWishlist();
}

function updateButtonState(productId, isActive) {
	const button = document.getElementById(`add-to-wishlist-${productId}`);
	if (button) {
		if (isActive) {
			button.classList.add("active");
		} else {
			button.classList.remove("active");
		}
	}
}

function renderWishlist() {
	const wishlistItems = document.getElementById("wishlist-items");
	if (wishlistItems) {
		wishlistItems.innerHTML = "";

		wishlist.forEach((productId) => {
			updateButtonState(productId, true);
		});

		const fetchProductPromises = wishlist.map((productId) => {
			return fetch(`/products/${productId}.js`)
				.then((response) => response.json())
				.catch((error) => console.error("Ошибка при получении товара:", error));
		});

		Promise.all(fetchProductPromises).then((products) => {
			products.forEach((product) => {
				const productTemplate = `
			  <li>
				 <img src="${product.images[0]}" alt="${product.title}" style="width: 50px;">
				 <span>${product.title}</span>
				 <span>$${(product.price / 100).toFixed(2)}</span>
			  </li>
			`;
				wishlistItems.insertAdjacentHTML("beforeend", productTemplate);
			});
		});
	}
}

document.addEventListener("DOMContentLoaded", function () {
	renderWishlist();
});
*/

function updateCart() {
	fetch("/cart.js")
		.then((response) => response.json())
		.then((cart) => {
			const cartUpdatedEvent = new CustomEvent("cart:updated", {
				detail: cart,
			});
			document.dispatchEvent(cartUpdatedEvent);
		});
}

document.querySelectorAll('button[name="add"]').forEach((button) => {
	button.addEventListener("click", function () {
		updateCart();
	});
});

document.addEventListener("cart:updated", function (event) {
	const cart = event.detail; // Получаем данные о корзине
	console.log("cart updated!", cart);
});
